import {
  collection,
  getDocs,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import Failure from "../../../core/Failure";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import { INumber } from "@leedpulse-monorepo/interfaces";

async function getNumbersFromSenders(
  senders: string[]
): Promise<{
  numbers: INumber[];
}> {
  try {
    const db = firestore;
    const numbersCollection = collection(db, FirestoreCollections.numbers);

    if (senders.length === 0) {
      return {
        numbers: []
      };
    }

    const MAX_CHUNK_SIZE = 10;
    const chunks: string[][] = [];
    for (let i = 0; i < senders.length; i += MAX_CHUNK_SIZE) {
      chunks.push(senders.slice(i, i + MAX_CHUNK_SIZE));
    }

    const chunkResults = await Promise.all(
      chunks.map((chunk) =>
        getDocs(
          query(numbersCollection, where("sender", "in", chunk), orderBy("created", 'desc'))
        )
      )
    );

    const numbers: INumber[] = [];
    chunkResults.forEach((result) => {
      result.docs.forEach((doc) => {
        numbers.push(doc.data() as INumber);
      });
    });

    numbers.sort((a, b) => b.created - a.created);

    return {
      numbers
    };
  } catch (e) {
    console.log("error: ", e);
    throw new GetNumbersFromSendersFailure();
  }
}

export class GetNumbersFromSendersFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default getNumbersFromSenders;
